module.exports = __webpack_public_path__ + "media/images/arrow-right-02-77880b17e6f1632407f4dc3e8f300218.svg";